import { useState } from 'react';

import Badge from '../Badge/Badge';

import styles from "./card.module.css";
import dotsThreeOutlineVertical from '../../icons/dotsThreeOutlineVertical.svg'

export default function CardHeader({ chevron, title, label, menu, button }) {
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  return (
    <div className={styles.header}>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>
          {chevron && chevron}
          {title}
        </h2>
        {label && <Badge type='default' text={label} /> }
      </div>

      <div className={styles.wrapper}>
        {button && button}
        {menu &&
          <button
            className={styles.button}
            onClick={() => setMenuIsOpen(!menuIsOpen)}
          >
            <img src={dotsThreeOutlineVertical} width="15px" height="15px"/>
            {menuIsOpen &&
              <div className={styles.menu}>
                { menu }
              </div>
            }
          </button>
        }
      </div>
    </div>
  )
}
